import React from 'react';
import { Link } from 'react-router-dom';

const ServicesTwo = () => {
    return(
        <>
        {/*Services Section*/}
        <section className="services-section section-padding-all">
            <div className="internal-container">
            <div className="row clearfix">
                <div className="col-lg-3 col-md-4 col-sm-6 m-b30">
                <div className="image-effect-one hover-shadow">
                    <img src="images/pic1.png" alt="" />
                    <div className="figcaption">
                    <h4>Construction</h4>
                    <p>Engineering your dreams.</p>
                    <Link to="#"><i className="link-plus bg-primary" /></Link>
                    </div>
                </div>
                </div>
                <div className="col-lg-3 col-md-4  col-sm-6 m-b30">
                <div className="image-effect-one hover-shadow">
                    <img src="images/pic2.png" alt="" />
                    <div className="figcaption">
                    <h4>Architecture</h4>
                    <p>Life is Architecture.</p>
                    <Link to="#"><i className="link-plus bg-primary" /></Link>
                    </div>
                </div>
                </div>
                <div className="col-lg-3 col-md-12 col-sm-6 m-b30">
                <div className="mt-box our-speciallization-content">
                    <h3 className="m-t0"><span className="font-weight-100">Building</span> <br />It better in concrete.</h3>
                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy</p>
                    <Link to="#" className="ploting-btn btn-style-five">View All</Link>
                </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 m-b30">
                <div className="image-effect-one hover-shadow">
                    <img src="images/pic3.png" alt="" />
                    <div className="figcaption">
                    <h4>Renovation</h4>
                    <p>Dazzling Design</p>
                    <Link to="#"><i className="link-plus bg-primary" /></Link>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </section>
        {/*End Services Section*/}
        </>
    )
}

export default ServicesTwo;